export const webVitalsColors = ["green", "yellow", "red"];
export const chartColors = [
  "Black",
  "Gray",
  "Blue",
  "Fuchsia",
  "red",
  "orange",
  "green",
];
